import { render, staticRenderFns } from "./CheckDetailsCard.vue?vue&type=template&id=13310708&scoped=true"
import script from "./CheckDetailsCard.vue?vue&type=script&lang=js"
export * from "./CheckDetailsCard.vue?vue&type=script&lang=js"
import style0 from "./CheckDetailsCard.vue?vue&type=style&index=0&id=13310708&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13310708",
  null
  
)

export default component.exports